import {useIntl} from 'react-intl'

/** Prefer this hook in feature modules (`app/modules/*`) for user-facing copy. */
export function useAppIntl() {
  return useIntl()
}
